import React, { useEffect, useState } from 'react'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@emotion/react'
import { createThemeApp } from '../../../theme'
import { useParams } from 'react-router-dom'
import AuthServiceTransient from '../../../service/AuthServiceTransient'
import { extractErrorMessage } from '../../../utils/helper'
import { enqueueSnackbar } from 'notistack'

export function BodyWrapper({ children }) {
    const { jwt } = useParams()
    const [theme, setTheme] = useState()
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        AuthServiceTransient.load(jwt).then(async () => {
            console.log('Dados do usuário/empresa carregados com sucesso')
            setLoaded(true)
        }).catch(err => {
            console.log(err)
            extractErrorMessage(err, 'Erro ao carregar dados do usuário').then(msg => {
                enqueueSnackbar('Falha ao carregar dados do usuário/empresa carregados: ' + msg, { variant: 'error' })
            })
        })
    }, [jwt])

    useEffect(() => {
        setTheme(createThemeApp('light'))

        function changeTheme(message) {
            const { data } = message

            if (!data) return

            let dataJson = data

            if (typeof data === 'string') {
                try {
                    dataJson = JSON.parse(data)
                } catch (err) {
                    console.error('Erro ao fazer parse do tema:', err)
                    return
                }
            }

            if (dataJson?.newThemeMode) {
                const newTheme = createThemeApp(dataJson.newThemeMode)
                setTheme(newTheme)
            }
        }

        window.addEventListener('message', changeTheme)

        const observer = new ResizeObserver(() => {
            const size = document.body.scrollHeight + 50

            window.parent.postMessage({ size, type: 'resize-event' }, process.env.REACT_APP_RETAGUARDA_URL)
        })

        observer.observe(document.body)

        return () => {
            observer.disconnect()
            window.removeEventListener('message', changeTheme)
        }
    }, [])

    if (!theme || !loaded) {
        return null
    }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <style jsx="true" global="true">
                {`body {
                    margin: 0;
                    overflow: hidden;
                    background-color: ${theme.palette.background.paper};
                }`}
            </style>
            {children}
        </ThemeProvider>
    )
}